import { EXPLORER_BASE_URL, CORE_EXPLORER_BASE_URL } from "@/config/constants";

export function createExplorerLink(txHash: string): string {
  return `${EXPLORER_BASE_URL}/tx/${txHash}`;
}

export function createExplorerAddressLink(address: string): string {
  return `${EXPLORER_BASE_URL}/address/${address}`;
}

export function createCoreExplorerAddressLink(address: string): string {
  return `${CORE_EXPLORER_BASE_URL}/address/${address}`;
}
